<template>
  <div class="path pb-9 pt-1">
    <router-link to="/" class="mr-1">Home</router-link>
    <span v-for="path in paths" :key="path.name" class="ml-2">
      <svg
      style="margin-right: 10px;"
        width="21"
        height="10"
        viewBox="0 0 31 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
          fill="#8B857D"
        />
      </svg>

      <router-link :to="path.to" class="">{{ path.name }}</router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: "PathNavigation",
  props: {
    paths: Array,
  },

  data() {
    return {};
  },

  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.path {
  display: flex;
  align-items: center;
  a {
    color: #8b857d;
    text-decoration: none;
    font-weight: 400 !important;
  }
  @media (max-width: 800px) {
   flex-direction: column;
  }
  @media (max-width: 425px) {
    margin-top: -2rem;
    padding-bottom: 20px !important;
  }
}
</style>
